import Http from './http';
import { appendUrlParams } from '../utils/appendUrlParams';
export const getFiles = (payload) => {
    return Http.get('/files', payload);
};
export const getFilesDwg = (path) => {
    return Http.get(`/filenames/${path}`);
};
export const getFilesID = (id) => {
    return Http.get(`/files/${id}`);
};
export const getSolutionDetails = (id, solutionId) => {
    return Http.get(`/files/${id}/solutions/${solutionId}`);
};
export const getConfig = () => {
    return Http.get('/config?article=false');
};
export const deleteSolutionSystem = (id, solutionId) => {
    return Http.delete(`/files/${id}/solutions/${solutionId}`);
};
export const updateSolutionSystem = (id, solutionId, payload) => {
    return Http.put(`/files/${id}/solutions/${solutionId}/systems`, payload);
};
export const getArticleNumbers = (id) => {
    return Http.get(`/articles/${id}`);
};
export const getArticleDetails = (id, length, height) => {
    const baseUrl = `/article/${id}`;
    const params = { length, height };
    const fullUrl = appendUrlParams(baseUrl, params);
    return Http.get(fullUrl);
};
export const getArticleDescriptionDetails = (id, length, height) => {
    const baseUrl = `/article/${id}?name=true`;
    const params = { length, height };
    const fullUrl = appendUrlParams(baseUrl, params);
    return Http.get(fullUrl);
};
export const getArticleDescription = (id) => {
    return Http.get(`/articles/${id}?name=true`);
};
